import { DOCUMENT, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import 'moment-timezone';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
import _ from 'lodash';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';
// import moment from 'moment';
// import { Moment } from 'moment';
//  import moment from 'moment-timezone';
@Component({
  selector: 'app-locator-history',
  templateUrl: './locator-history.component.html',
  styleUrls: ['./locator-history.component.scss']
})
export class LocatorHistoryComponent implements OnInit {

  public tzNames: string[];
  public selectedTz: string = "Asia/Calcutta";
  public utcDate: moment.Moment;
  public tzDate: moment.Moment;
  projectId: any;
  locatorReportData: any;
  locatorReportTableData : any;
  locatorReportDataCopy : any;
  projectData: Object;
  projectName: any;
  count: Number = 10;
  locatorLogDataS: {};
  locatorLogData: any;
  resultCount = ["10","20","30","40","50"];
  enableCheckBox: boolean = true;
  indexFormArray: UntypedFormArray;
  form:UntypedFormGroup;
  enableLocatorTab: boolean = false;
  disableHistoryTab: boolean = true;
  ids=["",""];
  ids1: any;
  searchString: string;
  locatorReportDataForList1: any;
  locatorReportDataForList2: any;
  list1: any;
  list2: any;
  item: object;
  jsonToBeUsed: any[];
  jsonToBeUsedForList1: any[];
  jsonToBeUsedForList2: any[];
  dataForDateRange: any;
  toDate:any ;
  fromDate: any;
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Locator History',
    data: undefined,
  }
  previousUrl: any=[];
  currentUrl: any;
  previousUrltemp: any;
  agentCheck: boolean;
  today: any;

  constructor(
  private report: ReportService,
  private project: ProjectService,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private toastrService:ToastrService,
  private _router: Router,
  private urlService: UrlService,
  private memoryService: MemoryService,
  private datePipe: DatePipe,
  private confirmationDialogService:ConfirmationDialogService,
  private homeService: HomeService,
  @Inject( DOCUMENT ) private document: Document,
  ) { 
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.tzNames = moment.tz.names();
    this.timeZoneChanged(this.selectedTz);
  }
  
  @ViewChild('locatorChanges',null) locatorChanges: ElementRef;
countChange(value){
this.count = value;
this.loadLocator(this.fromDate,this.toDate,this.count);
}
  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.initFromToDate()
    //console.log(this.fromDate, this.toDate);
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
       this.project.getProjectById(this.projectId).subscribe(
         (data)=>{
           this.projectData = data;
           this.headerOptions.data = { 
            projectId : this.projectId,
            projectName: data['projectName']
          };
          this.homeService.setHeaderOptions(this.headerOptions);
           //console.log(this.projectData);
          //  this.projectName = this.projectData.projectName
         }
       )
       this.loadLocator(this.fromDate,this.toDate,this.count);
      }
    )
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this._router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this._router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
initFromToDate()
{
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2,"0");
  var date  =  String(today.getDate()).padStart(2,"0")
  this.toDate = year + "-" + month + "-" + date;
  
  const now = new Date();
  var lastWeek = new Date(now.getFullYear(), now.getMonth(), 1);
  var year1 = lastWeek.getFullYear();
  var month1 = String(lastWeek.getMonth() + 1).padStart(2,"0");
  var date1  =  String(lastWeek.getDate()).padStart(2,"0")
  this.fromDate = year1 + "-" + month1 + "-" + date1;
  this.today =  this.datePipe.transform(new Date(), 'yyyy-MM-dd');
}

loadLocator(fromDate,toDate,count){
  //console.log(fromDate);
  //console.log(toDate);
  let fDate = Math.floor(new Date(new Date(fromDate).setHours(0,0,0)).getTime());
  let tDate =  Math.floor(new Date(new Date(toDate).setHours(23,59,59)).getTime());
  let e =  Math.floor(new Date(new Date(this.today).setHours(23,59,59)).getTime());
  
  if(tDate > e )
  {
    this.toastrService.info('Please select current or past date');
    return
  }
  
  if(tDate < fDate){
    this.toastrService.info('Please select end date after start date');
    return;
  }
 

  // this.fromDate = Math.floor(new Date(updateLocatorHistoryForm.value.fromDate).getTime());
  // this.toDate =   Math.floor(new Date(updateLocatorHistoryForm.value.toDate).getTime());


  this.report.getLocatorHistory(this.projectId,fDate,tDate,count).subscribe((
    data=>{
      if(!data['loggingList'])
      {
          this.toastrService.clear();
          this.toastrService.info("No Records found, please change the date and try again ");
      }
      this.locatorReportData = data['loggingList'];
      //console.log(this.locatorReportData);
     
      for (var i = 0; i <  this.locatorReportData.length; i++) {
        this.locatorLogData = this.locatorReportData[i];
        var obj = JSON.parse(this.locatorLogData.entity);
       
        if (obj && obj.locatorSuite) {
            if (obj.locatorSuite.parentLocatorId) {
                // var parentLocator = homeService.getLocatorNodeById(obj.locatorSuite.parentLocatorId);
                // locatorLogData.module = parentLocator && parentLocator.title ? parentLocator.title : '';
            }
            this.locatorLogData.screen = obj.locatorSuite.name;
            this.locatorLogData.list = obj.locatorSuite.locatorEntryMap;
            this.locatorLogData.isSelected = false;
            this.locatorReportData[this.locatorLogData.id] = this.locatorLogData;
        } else if (obj) {
            if (obj.parentLocatorId) {
                // var parentLocator = homeService.getLocatorNodeById(obj.parentLocatorId);
                // locatorLogData.module = parentLocator && parentLocator.title ? parentLocator.title : '';
            }
            this.locatorLogData.screen = obj.name;
            this.locatorLogData.list = obj.locatorEntryMap;
            this.locatorLogData.isSelected = false;
            this.locatorReportData[this.locatorLogData.id] = this.locatorLogData;
        }
      } 

      this.locatorReportTableData =  JSON.parse(JSON.stringify(this.locatorReportData))
      this.locatorReportDataCopy = JSON.parse(JSON.stringify(this.locatorReportData))

      this.locatorReportData.map((element,index) => {
        let time = moment(element.date, "x").tz(this.selectedTz).format(" MMM DD YYYY hh:mm a");
        element.date = time;
       });

      //console.log(this.locatorReportData, this.locatorReportDataCopy);
    }
  ))
}

sendScreenName(screen){
 const sameScreenName =  this.locatorReportData.filter((f)=>f.screen==screen);
 //console.log(sameScreenName);
if(screen){

}
//console.log(screen);
this.enableCheckBox = false
}

onChange(screen:string, id,isChecked: boolean) {
  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;

  if(isChecked) {
    this.locatorReportData =  this.locatorReportData.filter((f)=>f.screen==screen);
    if(this.indexFormArray.value.length< 1){
      this.toastrService.clear();
      this.toastrService.info('select second to compare');
    }
   
    //console.log(this.indexFormArray.value.length)
    //console.log(this.indexFormArray.value);
     

    this.indexFormArray.push(new UntypedFormControl(screen));
    this.indexFormArray.push(new UntypedFormControl(id));
    //console.log(this.indexFormArray.value);
     if(this.indexFormArray.value.length == 4){
      this.toastrService.clear();
      //console.log(this.indexFormArray.value);
      this.ids[0] = this.indexFormArray.value[1];
      this.ids[1] = this.indexFormArray.value[3];
      this.locatorReportDataForList1 = this.locatorReportData.filter((f)=>f.id==this.ids[0]);
      this.locatorReportDataForList2 = this.locatorReportData.filter((f)=>f.id==this.ids[1]);
      this.list1 =  this.locatorReportDataForList1[0].list;
      this.list2 =  this.locatorReportDataForList2[0].list;
      // //console.log('list1>>',this.list1);
      // //console.log('list2>>',this.list2);
   
      // //console.log( '1',this.locatorReportDataForList1);
      // //console.log( '2',this.locatorReportDataForList2);
      // //console.log(this.ids,'>>');

this.jsonToBeUsedForList1 = [];

for (var type in  this.list1) {
    this.item = {};
    this.item['key'] = type;
    this.item['value'] =  this.list1[type];
    this.jsonToBeUsedForList1.push(this.item);
}
//console.log(this.jsonToBeUsedForList1);


this.jsonToBeUsedForList2 = [];

for (var type in  this.list2) {
    this.item = {};
    this.item['key'] = type;
    this.item['value'] =  this.list2[type];
    this.jsonToBeUsedForList2.push(this.item);
}

    this.enableLocatorTab = true;
    this.disableHistoryTab = false;
    // this.locatorChanges.nativeElement.click();
    // this.showLocatorChanges(this.ids[0],this.ids[1])

    setTimeout(() => {
      
      this.showLocatorChanges(this.ids[0],this.ids[1])
      this.locatorChanges.nativeElement.click();
    }, 0);
 }
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == screen)
    this.indexFormArray.removeAt(Index);
    //console.log(this.indexFormArray.value)
  }
}

onFilterLocatorHistory(updateLocatorHistoryForm){
  //console.log(this.fromDate, this.toDate);
  let fromDate = Math.floor(new Date(updateLocatorHistoryForm.value.fromDate).getTime());
  let toDate =   Math.floor(new Date(updateLocatorHistoryForm.value.toDate).getTime());
  //console.log('from',fromDate , 'to', toDate);
  this.loadLocator(fromDate,toDate,this.count);
  // this.loadLocator(this.count);
  // this.locatorReportData = this.locatorReportData.filter(e=> e.date >= this.fromDate && e.date <= this.toDate);
  // //console.log(this.locatorReportData);
}
applyDateFilter() {
  //console.log(this.form);
 
  this.dataForDateRange = this.locatorReportData.filter(e=> e.date >= this.form.value.fromDate && e.date <= this.form.value.toDate);
}

closeChange(){
  this.enableLocatorTab = false;
    this.disableHistoryTab = true;
    this.refreshPage();
}
refreshPage() {
  this.document.defaultView.location.reload();
}

public timeZoneChanged(timeZone: string): void {
  //console.log(timeZone, this.locatorReportDataCopy, this.locatorReportData);
  if(this.locatorReportDataCopy)
  {
    this.locatorReportData = JSON.parse(JSON.stringify(this.locatorReportDataCopy));
    //console.log(this.locatorReportData, this.locatorReportDataCopy)
  }
  
  if(this.locatorReportData)
  {
        this.locatorReportData.map((element,index) => {
          // let time1 = moment(element.date, "x").tz(timeZone).unix();
          let time = moment(element.date, "x").tz(timeZone).format(" MMM DD YYYY hh:mm a");
          // //console.log(time, element.date, time1)
          element.date = time;
          //element.date = time;
         });
         //console.log("-----------------------------------------------------");
  }

  ////console.log(this.locatorReportData);

  this.tzDate = moment('Mar 24, 2022 14:46:40').tz(timeZone);
  this.selectedTz = timeZone;

 // this.updateTime(timeZone);
}


private updateTime(timeZone: string) {
  const currentTime = new Date().getTime();
  // this.utcDate = moment(currentTime).utc();
  // this.tzDate = moment(currentTime).tz(timeZone);
}


demo()
{
  
  //console.log(this.tzDate);
}

showLocatorChanges = function (index, indexToCompare) {
 var locatorLogDataS1 = this.locatorReportData.filter((f)=>f.id==index);
  var nextMap = locatorLogDataS1[0].list;
  var nextDate = locatorLogDataS1[0].date;
  var next = new Array();
  _.map(nextMap, function (value, key) {
      var object = new Object();
      object['key'] = key;
      object['value'] = value;
      next.push(object);
  });
var locatorLogDataS2=this.locatorReportData.filter((f)=>f.id==indexToCompare);
  var prevMap = locatorLogDataS2[0].list;
  var prevDate = locatorLogDataS2[0].date;
  var prev = new Array();
  _.map(prevMap, function (value, key) {
      var object = new Object();
      object['key'] = key;
      object['value'] = value;
      prev.push(object);
  });

  var prevLength = prev.length;
  var nextLength = next.length;

  var mergeData = new Array();

  var length = prevLength > nextLength ? nextLength : prevLength;

  for (var i = 0; i < length; i++) {
      var pushData = new Object();
      pushData['prevData'] = prev[i];
      pushData['nextData'] = next[i];
      pushData['compare'] = this.locatorCompare(pushData['prevData'], pushData['nextData']);
      mergeData.push(pushData);
  }

  for (var i = length; i < prevLength; i++) {
      var pushData = new Object();
      pushData['prevData'] = prev[i];
      pushData['nextData'] = {
          "key": "",
          "value": ""
      };
      pushData['compare'] = this.locatorCompare(pushData['prevData'], pushData['nextData']);
      mergeData.push(pushData);
  }

  for (var i = length; i < nextLength; i++) {
      var pushData = new Object();
      pushData['prevData'] = {
          "key": "",
          "value": ""
      };
      pushData['nextData'] = next[i];
      pushData['compare'] = this.locatorCompare(pushData['prevData'], pushData['nextData']);
      mergeData.push(pushData);
  }
  console.log(mergeData);
  this.dataForComparison = mergeData;
  // this.locatorChanges.nativeElement.click();
};

locatorCompare = function (previous, next) {
  var compare = new Object();
  compare['key'] = previous.key === next.key ? true : false;
  compare['value'] = previous.value === next.value ? true : false;
  compare['equal'] = compare['key'] && compare['value'];
  return compare;
};

resetHistory(){
  console.log('clicked reset');
  
  this.reloadComponent()
}

reloadComponent() {
  let currentUrl = this._router.url;
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
      this._router.navigate([currentUrl]);
  }
}
